// extracted by mini-css-extract-plugin
module.exports = {"writingSideways":"LeadershipPillars_writingSideways__QJ_n_"};